import styled from '@emotion/styled';
import { Table } from 'antd';
import { sumBy } from 'lodash';
import { useEffect, useState } from 'react';
import { formatNum } from '../../../../../shared/constants';

const Container = styled.div`
  color: black;
`;

export const BGTitulaire = ({ bg }: { bg: any[] }) => {
  const [bgTitulaire, setBGTitulaire] = useState<any[]>([]);

  useEffect(() => {
    if (bg.length !== 0) {
      setBGTitulaire([
        ...bg,
        {
          titulaire: 'Total',
          sum_credit: sumBy(bg, 'sum_credit'),
          sum_debit: sumBy(bg, 'sum_debit'),
          sum_solde: sumBy(bg, 'sum_solde'),
        },
      ]);
    }
  }, [bg]);

  return (
    <Container>
      <Table
        columns={COLUMNS}
        dataSource={bgTitulaire}
        rowClassName={(row, index) =>
          index % 2 === 0 ? 'even-row' : 'odd-row'
        }
        size='small'
        loading={bg.length === 0 ? true : false}
        style={{ zoom: 0.9 }}
        pagination={false}
        scroll={{ x: 'max-content' }}
      />
    </Container>
  );
};

const COLUMNS = [
  {
    title: 'Titulaire',
    dataIndex: 'titulaire',
  },
  {
    title: 'Cumul Crédit',
    dataIndex: 'sum_credit',
    render: (cell: any) => `${formatNum(cell)}`,
  },
  {
    title: 'Cumul Débit',
    dataIndex: 'sum_debit',
    render: (cell: any) => `${formatNum(cell)}`,
  },
  {
    title: 'Solde',
    dataIndex: 'sum_solde',
    render: (cell: any) => `${formatNum(cell)}`,
  },
];
